export const GET_ORGANISATION_REQUEST = '@organisations/GET_ORGANISATION_REQUEST';
export const GET_ORGANISATION_SUCCESS = '@organisations/GET_ORGANISATION_SUCCESS';
export const GET_ORGANISATION_ERROR = '@organisations/GET_ORGANISATION_ERROR';
